import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { LOCALIZATION_KEY } from '../../constants';
import { ProfileReportLayout } from '../../profile/models/profile-report-sections';

@Component({
  selector: 'ca-modify-report-drawer-footer',
  templateUrl: './modify-report-drawer-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModifyReportDrawerFooterComponent {
  localizationScope = LOCALIZATION_KEY;
  @Input() disableSaving = false;
  @Input() createReportTitle!: string;
  @Input() isConfigurable!: boolean;
  @Input() templateId?: number;
  @Output() closeDrawer = new EventEmitter();
  @Output() createReport = new EventEmitter();
  @Output() previewAndCustomize = new EventEmitter();

  ProfileReportLayout = ProfileReportLayout;

  cancel() {
    this.closeDrawer.emit();
  }

  onCreateReport() {
    this.createReport.emit();
  }

  getExportReportLink() {
    return `reporting/template-designer/export?id=${this.templateId}`;
  }

  onPreviewAndCustomizeClick() {
    this.previewAndCustomize.emit();
  }
}
